/** @format */

import { Alert, AlertColor, Snackbar } from "@mui/material";
import React from "react";

interface NotificationProps {
	open: boolean;
	message: string;
	severity?: AlertColor;
	onClose: () => void;
	autoHideDuration?: number;
}

const SuccessNotification: React.FC<NotificationProps> = ({
	open,
	message,
	severity,
	onClose,
	autoHideDuration,
}) => {
	return (
		<Snackbar
			open={open}
			autoHideDuration={autoHideDuration}
			onClose={onClose}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}>
			<Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default SuccessNotification;
